import {
  Scoreboard,
  ScoreboardParticipant,
  ScoreboardParticipants,
  ScoreboardScore,
  ScoreboardScores
} from '@ps/isp-web-component-library';
import type { EnrichedParticipants, EventId } from '@ps/isp-web-services-types';
import type { EsportsFixture } from '@ps/web-shared-generated-graphql/sports';
import React from 'react';

import { EventTypeId } from '@swf/sports/types/eventType';
import { getScoreCharacterLength } from '@swf/sports/utils/getScoreCharacterLength';

import ScoreboardWrapper from '../ScoreboardWrapper/ScoreboardWrapper';

interface Props {
  enrichedParticipants?: EnrichedParticipants;
  eventId: EventId;
  eventTime: string;
  eSportsFixture?: EsportsFixture;
}

const getParticipantScore = (
  participant: EnrichedParticipants[number],
  score: EsportsFixture['score'] | undefined
) => (participant.type === 'HOME' ? score?.home : score?.away);

const ESports: React.FC<Props> = ({ enrichedParticipants, eSportsFixture, eventId, eventTime }) => {
  const [participantA, participantB] = enrichedParticipants ?? [];

  const currentScore = participantA.type && participantB.type ? eSportsFixture?.score : null;

  return (
    <ScoreboardWrapper eventId={eventId} eventTime={eventTime} eventTypeId={EventTypeId.E_SPORTS}>
      <Scoreboard>
        <ScoreboardParticipants>
          <ScoreboardParticipant name={participantA.participant} />
          <ScoreboardParticipant name={participantB.participant} />
        </ScoreboardParticipants>
        <ScoreboardScores>
          <ScoreboardScore
            score={[
              getParticipantScore(participantA, currentScore) ?? null,
              getParticipantScore(participantB, currentScore) ?? null
            ]}
            scoreCharacterLength={getScoreCharacterLength(EventTypeId.E_SPORTS, [
              currentScore?.home ?? 0,
              currentScore?.away ?? 0
            ])}
          />
        </ScoreboardScores>
      </Scoreboard>
    </ScoreboardWrapper>
  );
};

export default ESports;
